import { Grid } from '@mui/material'
import React from 'react'
import DeletePage from './Components/DeleteUser/DeletePage'

const DeleteUser=()=>{
  return (
    <Grid container>
        <Grid item xs={12}>
            <DeletePage/>
        </Grid>
    </Grid>
  )
}

export default DeleteUser